export const CHECKOUT_URL = 'https://orthophonie-pro.impultienda.ar/checkout'
export const OFFER_ANCHOR = '#offre'
export const SUPPORT_EMAIL = 'kitonline27@gmail.com'
export const PIXEL_ID = '1037491992204255'

export const HERO_IMG =
  'https://cdn.magicpatterns.com/uploads/w4fmNZSssedWe2E2cBFWbb/Diseno_sin_titulo-2.png'
